import TransferItemsListPanel from "./transferItemsListPanel.container";
export default TransferItemsListPanel;
